import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D4B29470-8EE3-4ED8-BB01-6C942CE7E748
 * name delta
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delta.svg
 * tags
 * - Math 
 * - Alpha / Numeric 
 */
export const DeltaIcon = createSvgIcon(<><path d="M12,7.77L18.39,18H5.61L12,7.77M12,4L2,20H22" /></>, 'DeltaIcon');
export default DeltaIcon